import React, { useState } from "react";

const CopyURL = ({ label = "Copy URL", timeout = 2000 }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.preventDefault();

    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);

      setTimeout(() => setCopied(false), timeout);
    } catch (err) {
      console.error("Failed to copy URL", err);
    }
  };

  return (
    <button onClick={handleCopy} className="copy-link">
      {copied ? "URL Copied!" : "Copy URL"}
    </button>
  );
};

export default CopyURL;
